"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryNameValidateComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var commonFunctions_1 = require("../../commonFunctions");
var reactstrap_1 = require("reactstrap");
var services_1 = require("@falcon/services");
var SummaryNameValidateComponent = /** @class */ (function (_super) {
    __extends(SummaryNameValidateComponent, _super);
    function SummaryNameValidateComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            policyHolder: null,
            nameEditPopupOpen: false,
            policyHolderNameValid: (0, commonFunctions_1.isPolicyHolderNameValid)(_this.props.policyHolder)
        };
        _this.handleFullNameChange = _this.handleFullNameChange.bind(_this);
        _this.toggleEditFullNamePopup = _this.toggleEditFullNamePopup.bind(_this);
        _this.renderFullNameEditPopup = _this.renderFullNameEditPopup.bind(_this);
        _this.saveAndConfirm = _this.saveAndConfirm.bind(_this);
        _this.openEditNamePopup = _this.openEditNamePopup.bind(_this);
        return _this;
    }
    SummaryNameValidateComponent.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "detail", children: (0, jsx_runtime_1.jsxs)("div", { className: "detail-key policy-holder-name mb-2 fs-24 ".concat(this.state.policyHolderNameValid ? "" : "text-danger "), children: [this.props.policyHolder.firstName, " ", this.props.policyHolder.lastName] }) }), !this.state.policyHolderNameValid &&
                    (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { className: "text-danger ", children: "Your name appears to contain special characters that we don't accept." }) }), (0, jsx_runtime_1.jsx)("div", { className: "edit-phone-number mt-2", children: (0, jsx_runtime_1.jsx)("button", { className: "link-edit", onClick: this.toggleEditFullNamePopup, children: "Please update your name" }) })] }), this.state.nameEditPopupOpen && this.renderFullNameEditPopup()] }));
    };
    SummaryNameValidateComponent.prototype.renderFullNameEditPopup = function () {
        var title = "Update your name";
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.toggleEditFullNamePopup });
        return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "edit-name-modal my-2 info-modal", isOpen: this.state.nameEditPopupOpen, toggle: this.toggleEditFullNamePopup, close: closeBtn, children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.toggleEditFullNamePopup, children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("img", { className: "d-block warning-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-grey-blue.svg"), alt: "Attention icon" }), (0, jsx_runtime_1.jsx)("div", { className: "text-blue-2 font-weight-medium fs-20", children: title })] }) }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto", children: [(0, jsx_runtime_1.jsx)("div", { className: "mb-3", children: (0, jsx_runtime_1.jsx)("p", { className: "m-0", children: "Your name appears to contain special characters that we don't accept. Please update your name below" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "custom-margin-mobile-cut-sides mr-4 ml-4", children: [(0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "First name" }) }), (0, jsx_runtime_1.jsx)("div", { className: "col-md-7 d-flex p-0", children: (0, jsx_runtime_1.jsx)("input", { onChange: this.handleFullNameChange, type: "text", className: "form-control", id: "firstNameChange" }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "custom-margin-mobile-cut-sides mr-4 ml-4", children: [(0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "Last name" }) }), (0, jsx_runtime_1.jsx)("div", { className: "col-md-7 d-flex p-0", children: (0, jsx_runtime_1.jsx)("input", { onChange: this.handleFullNameChange, type: "text", className: "form-control" }) })] })] }), (0, jsx_runtime_1.jsxs)(reactstrap_1.ModalFooter, { className: "d-block custom-margin-mobile-cut-sides", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary ".concat(this.state.policyHolderNameValid ? "" : "btn-disabled ", " btn-next-arrow-separate width-md-250"), onClick: this.saveAndConfirm, children: "Save and continue" }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back width-md-250", onClick: this.toggleEditFullNamePopup, children: "Cancel" })] })] }));
    };
    SummaryNameValidateComponent.prototype.openEditNamePopup = function () {
        this.setState(function (prevState) { return ({
            nameEditPopupOpen: !prevState.nameEditPopupOpen
        }); });
    };
    SummaryNameValidateComponent.prototype.toggleEditFullNamePopup = function () {
        var _this = this;
        this.setState(function (prevState) { return ({
            nameEditPopupOpen: !prevState.nameEditPopupOpen,
            policyHolderNameValid: (0, commonFunctions_1.isPolicyHolderNameValid)(_this.props.policyHolder)
        }); });
    };
    SummaryNameValidateComponent.prototype.handleFullNameChange = function (event) {
        var policyHolder = __assign({}, this.state.policyHolder);
        if (event.target.id === "firstNameChange") {
            policyHolder.firstName = event.target.value;
        }
        else {
            policyHolder.lastName = event.target.value;
        }
        if ((0, commonFunctions_1.isPolicyHolderNameValid)(policyHolder)) {
            this.setState({
                policyHolderNameValid: true,
                policyHolder: policyHolder
            });
        }
    };
    ;
    SummaryNameValidateComponent.prototype.saveAndConfirm = function () {
        this.props.onStateChange("policyHolder.firstName", this.state.policyHolder.firstName);
        this.props.onStateChange("policyHolder.lastName", this.state.policyHolder.lastName);
        this.toggleEditFullNamePopup();
    };
    return SummaryNameValidateComponent;
}(React.Component));
exports.SummaryNameValidateComponent = SummaryNameValidateComponent;
//# sourceMappingURL=SummaryNameValidateComponent.js.map